import React from "react";
import { bool, number, shape } from "prop-types";
import { FormattedMessage } from "react-intl";
import FormatCurrency from "../../currency/FormatCurrency";

function RequiredRuleUpdates({ requiredUpdates }) {
  let content = null;
  if (requiredUpdates) {
    if (requiredUpdates.extraCostsOnRequest) {
      content = (
        <FormattedMessage id="buyerPortal.roomBook.buyerSelection.confirmation.message.extraOnRequest" />
      );
    } else {
      content =
        requiredUpdates.extraCosts !== 0 ? (
          <FormattedMessage
            id="buyerPortal.roomBook.buyerSelection.confirmation.message.extra"
            values={{
              total: (
                <strong>
                  <FormatCurrency amount={requiredUpdates.extraCosts} />
                </strong>
              )
            }}
          />
        ) : null;
    }
  }

  return (
    <div>
      <h5>
        <FormattedMessage id="buyerPortal.roomBook.buyerSelection.confirmation.message.reset" />
      </h5>
      {content}
    </div>
  );
}

RequiredRuleUpdates.propTypes = {
  requiredUpdates: shape({
    extraCostsOnRequest: bool,
    extraCosts: number
  })
};

RequiredRuleUpdates.defaultProps = {
  requiredUpdates: undefined
};

export default RequiredRuleUpdates;
